import React from 'react';
import { useEffect } from 'react';
import { AccreditationFormProps, ChampionshipPlayer } from './types';
import { DataGridTable } from '../DataGridTable/DataGridTable';
import { useCommonUIActionsContext } from '../../contexts/CommonUIActionsContext';
import { getPPContactToDisplay } from '../../helpers/PlayerPortals/userManagement/getPPContactToDisplay';
import useFetchCurrentUserData from '../../hooks/useFetchCurrentUserData';
import { CHAMPIONSHIP_PLAYERS_QUERY_KEY } from '../../constants';

import styles from './AccreditationForm.module.scss';

export const AccreditationForm = ({
  title,
  columns = [],
  addNewRecordCTALabel,
  accreditationContactForm,
  maxNumberOfApplicationsPerRole,
  maxNumberOfNominatedForDinner,
  callbackUrl = '',
  accreditationFormKontentItemCodename,
  kontentItemId,
}: AccreditationFormProps) => {
  const defaultSortColumn = columns[1];

  const [players, setPlayers] = React.useState<ChampionshipPlayer[]>([]);
  const [selectedPlayerId, setSelectedPlayerId] = React.useState<string>('');

  const displayedPPContact = getPPContactToDisplay();
  const { preRegistrationAPI } = useCommonUIActionsContext() || {};
  const getPlayersByContactIdPath =
    process.env.NEXT_PUBLIC_GET_ALL_CHAMPIONSHIP_PLAYERS_BY_CONTACT_ID_PATH ||
    '';

  const { data } = useFetchCurrentUserData(
    getPlayersByContactIdPath,
    preRegistrationAPI,
    CHAMPIONSHIP_PLAYERS_QUERY_KEY,
    displayedPPContact?.id,
  );

  useEffect(() => {
    if (data?.items) {
      setPlayers(data.items);
      setSelectedPlayerId(data.items[0].id);
    }
  }, [data]);

  return (
    <div className={styles['container']} data-kontent-item-id={kontentItemId}>
      <DataGridTable
        playersTableLabel={title}
        managersTableLabel={title}
        columns={columns}
        rows={[]}
        defaultSortColumn={defaultSortColumn}
        defaultSortDirection="asc"
        callbackUrl={callbackUrl}
        accreditationGridTable={{
          players: players ?? [],
          selectedPlayerId: selectedPlayerId,
          setSelectedPlayerId: setSelectedPlayerId,
          addNewRecordCTALabel: addNewRecordCTALabel ?? '',
          accreditationContactForm: accreditationContactForm,
          maxNumberOfApplicationsPerRole: maxNumberOfApplicationsPerRole,
          maxNumberOfNominatedForDinner: maxNumberOfNominatedForDinner,
          accreditationFormKontentItemCodename:
            accreditationFormKontentItemCodename || '',
        }}
      />
    </div>
  );
};

export default AccreditationForm;
